import { render, staticRenderFns } from "./MenuTitle.vue?vue&type=template&id=2eb35ac8&scoped=true&"
import script from "./MenuTitle.vue?vue&type=script&lang=js&"
export * from "./MenuTitle.vue?vue&type=script&lang=js&"
import style0 from "./MenuTitle.vue?vue&type=style&index=0&id=2eb35ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb35ac8",
  null
  
)

export default component.exports